import React from "react";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ColorDisplayContainer } from "./styles";

interface ColorDisplayProps {
  /** Cor exibida na amostra. Vazio deixa a amostra transparente. */
  cor?: string;
  /** Sobrescreve a borda da amostra. Sem isso usa a borda neutra do tema. */
  corBorda?: string;
  /** Clique na amostra. Só com ele a amostra vira um controle (cursor e hover). */
  onClick?: () => void;
  className?: string;
  /** Conteúdo à direita da amostra. Sem isso mostra o próprio hex. */
  children?: React.ReactNode;
}

export const ColorDisplay: React.FC<ColorDisplayProps> = ({
  cor,
  corBorda,
  onClick,
  className = "",
  children,
}) => {
  const { theme } = useTheme();

  return (
    <ColorDisplayContainer
      theme={theme}
      className={`color-display fonteHex ${className}`.trim()}
    >
      <div
        className={`color-preview${onClick ? " clicavel" : ""}`}
        onClick={onClick}
        style={{ backgroundColor: cor, borderColor: corBorda }}
      />
      {children ?? <span className="color-code">{cor}</span>}
    </ColorDisplayContainer>
  );
};

export default ColorDisplay;